(function () {
  'use strict';

  /* @ngdoc object
   * @name events.guests
   * @description
   *
   */
  angular
    .module('events.guests', [
      'ui.router',
      'events.guests.list',
      'events.guests.view'
    ]);
}());
